import styled from "styled-components";

export const AccordionContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 72px;
`;